/**
 * StatsTracker - Records and summarizes player performance for the post-game screen
 */
export interface PlayerStats {
    playerId: string;
    damageDealt: number;
    fartCount: number;
    killCount: number;
    placement: number;
    timeSurvived: number;
    killedBy?: string;
}

export class StatsTracker {
    private stats: Map<string, PlayerStats> = new Map();
    private startTime: number = Date.now();
    private eliminationOrder: string[] = [];

    initPlayer(id: string): void {
        this.stats.set(id, {
            playerId: id,
            damageDealt: 0,
            fartCount: 0,
            killCount: 0,
            placement: 0,
            timeSurvived: 0,
        });
    }

    recordDamage(attackerId: string, amount: number): void {
        const stats = this.stats.get(attackerId);
        if (stats) stats.damageDealt += amount;
    }

    recordFart(playerId: string): void {
        const stats = this.stats.get(playerId);
        if (stats) stats.fartCount++;
    }

    recordElimination(victimId: string, killerId?: string): void {
        if (this.eliminationOrder.includes(victimId)) return;

        if (killerId) {
            const killer = this.stats.get(killerId);
            if (killer) killer.killCount++;
        }

        const victim = this.stats.get(victimId);
        if (victim) {
            victim.killedBy = killerId;
            victim.timeSurvived = Date.now() - this.startTime;
        }

        this.eliminationOrder.push(victimId);
    }

    finalize(activePlayerIds: string[]): PlayerStats[] {
        const totalInitial = this.stats.size;

        // Assign placements (reverse elimination order)
        // Those who died last get better placement
        let placement = totalInitial;
        this.eliminationOrder.forEach(id => {
            const stats = this.stats.get(id);
            if (stats) stats.placement = placement--;
        });

        // Those who haven't been eliminated are winners (placement 1)
        this.stats.forEach((stats, id) => {
            if (stats.placement === 0) {
                stats.placement = 1;
                stats.timeSurvived = Date.now() - this.startTime;
            }
        });

        return Array.from(this.stats.values())
            .sort((a, b) => a.placement - b.placement);
    }
}
